var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slidebox"},[_c('div',{staticClass:"slidebox-activator",on:{"click":_vm.toggle}},[_vm._t("activator",null,{"isOpen":_vm.open})],2),_c('div',{ref:"content",staticClass:"slidebox-content",style:(_vm.styleItems)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }